import moment from 'moment-timezone';
import { RBI_ORDER_STATUSES, SUPPORT_KEYWORD } from '../constants/rbi';

export const countRefundsForPastPeriod = (orders, period, dateType) => {
  const dateMarker = moment().subtract(period, dateType);

  return orders.reduce((totalRefundsCount, order) => {
    const isMadeAfterDate = moment(order.createdAt).isAfter(dateMarker);
    if (isMadeAfterDate && order.status === RBI_ORDER_STATUSES.REFUND_SUCCESSFUL) {
      totalRefundsCount++;
    }

    return totalRefundsCount;
  }, 0);
};

export const countOrderRemediationsForLastDays = (order, days) => {
  const dateMarker = moment().subtract(days, 'days');

  if (Array.isArray(order?.remediations)) {
    return order.remediations.reduce((count, remediation) => {
      if (moment(remediation.created).isAfter(dateMarker, 'day')) {
        count++;
      }

      return count;
    }, 0);
  }

  return 0;
};

export const isCouponIssuedBySupport = (coupon) => {
  return coupon?.name ? coupon.name.toLowerCase().includes(SUPPORT_KEYWORD.toLowerCase()) : false;
};
